import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * A point placed at the midpoint of a triangle's edge AB.
 *
 * Uses expression-based x/y on the Point element to compute the midpoint
 * from the edge's start and end coordinates.
 */
export const POINT_ON_EDGE_PRESET: GeometryPadWidgetConfig = {
  id: 'point-on-edge',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 6, c: 7 },
      },
      M: {
        type: 'Point',
        params: {
          x: '(t1.edge.AB.start.x + t1.edge.AB.end.x) / 2',
          y: '(t1.edge.AB.start.y + t1.edge.AB.end.y) / 2',
        },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
    elements: {
      M: {
        point: {
          visible: true,
          color: 'red',
          size: 5,
        },
      },
    },
  },
};
